export default "__VITE_ASSET__CU6QC5HO__"